<template>
  <card class="card-stats" :show-footer-line="true">
    <div class="row">
      <div class="col-4">
        <img :src="icon" :style="imgStyle">
      </div>
      <div class="col-8" v-if="$slots.content || title || subTitle">
        <div class="numbers">
            <p v-html="subTitle" class="card-category"></p>
            <h3 v-html="title" class="card-title" :style="titleSize"></h3>
        </div>
      </div>
    </div>
    <div class="stats" slot="footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </card>
</template>
<script>
import Card from './Card.vue';

export default {
  name: 'stats-card',
  components: {
    Card
  },
  props: {
    icon: String,
    title: String,
    titleSize: String,
    subTitle: String,
    imgStyle: String
  }
};
</script>
<style scoped>
.col-4 {
  padding-left: 9%;
  padding-right: 0%
}
.col-8 {
  padding-left: 5% 
}
</style>
